module.exports = __webpack_public_path__ + "static/media/microsoft.5ae0f940.svg";